import { FiCheck } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';

interface Option {
    value: string;
    label: string;
    icon?: string;
}

interface MenuFilterProps {
    options: Option[];
    value: string;
    onChange: (value: string) => void;
    title: string;
    className?: string;
}

const MenuFilter = ({ options, value, onChange, title, className = '' }: MenuFilterProps) => {
    const getIcon = (iconType?: string) => {
        if (iconType === 'whatsapp') return <FaWhatsapp className="text-green-500" size={14} />;
        if (iconType === 'email') return <MdMailOutline className="text-blue-500" size={14} />;
        return null;
    };

    return (
        <div className="space-y-2">
            {title && (
                <h4 className="text-xs font-semibold text-gray-600 dark:text-gray-300 uppercase tracking-wider">
                    {title}
                </h4>
            )}
            <div className={`space-y-1 ${className}`}>
                {options.map((option) => (
                    <button
                        key={option.value}
                        onClick={() => onChange(option.value)}
                        className={`w-full flex items-center justify-between px-3 py-2 text-sm rounded-lg transition-all duration-200 text-left group min-w-0 ${
                            value === option.value
                                ? 'bg-blue-600 text-white shadow-md transform scale-[1.02]'
                                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 hover:shadow-sm'
                        }`}
                    >
                        <div className="flex items-center space-x-2 flex-1 min-w-0">
                            {getIcon(option.icon)}
                            <span className="truncate font-medium flex-1">{option.label}</span>
                        </div>
                        {value === option.value && (
                            <FiCheck className="text-white flex-shrink-0 ml-2" size={14} />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default MenuFilter;
